module.exports = "<p>\r\n  ritel-online works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/ritel-online.component.html
// module id = ../../../../../src/app/ritel-online/ritel-online.component.html
// module chunks = 1